var TooltipTriggers;
(function (TooltipTriggers) {
    TooltipTriggers["Hover"] = "hover";
    TooltipTriggers["Click"] = "click";
})(TooltipTriggers || (TooltipTriggers = {}));
var Placements;
(function (Placements) {
    Placements["Auto"] = "auto";
    Placements["AutoStart"] = "auto-start";
    Placements["AutoEnd"] = "auto-end";
    Placements["Top"] = "top";
    Placements["TopStart"] = "top-start";
    Placements["TopEnd"] = "top-end";
    Placements["Bottom"] = "bottom";
    Placements["BottomStart"] = "bottom-start";
    Placements["BottomEnd"] = "bottom-end";
    Placements["Left"] = "left";
    Placements["LeftStart"] = "left-start";
    Placements["LeftEnd"] = "left-end";
    Placements["Right"] = "right";
    Placements["RightStart"] = "right-start";
    Placements["RightEnd"] = "right-end";
})(Placements || (Placements = {}));

export { Placements, TooltipTriggers };
